/** @jsxImportSource @emotion/react */
import React, { FC, PropsWithChildren } from 'react';
import { AppBar, Box, Container, css, useTheme } from '@mui/material';
import HideOnScroll from 'components/HideOnScroll';
import { Props } from './types';

const Header: FC<PropsWithChildren<Props>> = ({ hide, children }) => {
  const theme = useTheme();

  return (
    <>
      <HideOnScroll hide={hide}>
        <AppBar
          elevation={0}
          css={css`
            background-color: ${theme.palette.background.default};
            height: auto;
          `}
        >
          <Container maxWidth="sm">{children}</Container>
        </AppBar>
      </HideOnScroll>

      <Box pt={8} />
    </>
  );
};

export default Header;
